module.exports=function(scope){ return `String deviceLicenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";
String serverLicenseKey = "<THIS_KEY_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>";
String encryptionKey = "<THIS_IS_YOUR_ENCRYPTION_KEY>";

// Key file is an extra required paramter for SFTP Log mode only.
// Note: You may also initialize using a licenseText string if you do not want to work with files. This MUST BE the EXACT text from your Key.  If you modify the text, Key validation will fail. 
File licenseFile = new File("<THIS_IS_THE_PATH_TO_YOUR_LICENSE_FILE>");

// (Optional) Create configuration object that sets custom directory for the FaceTec SDK to unpack temporary resource files. Compatible with both Key types.
ZoomInitializeConfig initConfig = new ZoomInitializeConfig();
config.workingDirectoryPath = "<THIS_IS_YOUR_CUSTOM_DIRECTORY_PATH>";

// Initialize using a Server SDK LicenseFile and a Device SDK Key - SFTP Log mode
// @param - licenseFile - This is the file containing Key data that FaceTec generated for you. Your Key (s) can be downloaded here -- https://dev.facetec.com/zoomsdk/#/account
// @param - deviceLicenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - serverLicenseKey - This is your Server Key . You can get your Server Key  here: https://dev.facetec.com/zoomsdk/#/account
// @param - encryptionKey - This is the contents of your ZoomServer_private.pem as a string
//
// @throws - initException - This is a ZoomInitException object that is thrown if initialization was not successful. This contains the ZoomInitError object as a property
//
try {
    ZoomAuthenticationInstance zoomInstance = ZoomAuthentication.initializeWithLicense(licenseFile, deviceLicenseKeyIdentifier, serverLicenseKey, encryptionKey, initConfig);
}
catch (ZoomInitException initException) {
    // Handle exception
}`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/server/00-initialize-prod.java.tpl